import { Suspense, lazy } from 'react';
import LineChartSkeleton from '../skeleton/LineChartSkeleton';

const CourbeAmelioree = lazy(() => import('./Courbe'));

const CourbeWrapper = ({ selectedYear }) => {
  return (
    <Suspense fallback={<LineChartSkeleton />}>
      <CourbeAmelioree selectedYear={selectedYear} />
    </Suspense>
  );
};

export default CourbeWrapper;